import { urls } from "app/constants";
import { useApi } from "./index";

export const useApiCategories = () =>
  useApi({ url: urls.wishCategories, method: "get" });
